// Copyright 2026. WebPros International GmbH. All rights reserved.

import { IGpuResponse } from 'common/api/resources/Gpu';
import {
    FC,
    memo,
} from 'react';
import {
    Action,
    List,
    Translate,
} from '@plesk/ui-library';
import { pathTo } from 'common/helpers/core';

interface IProps {
    gpu: IGpuResponse;
}

const COLUMNS = [
    {
        key: 'colPlacementID',
        title: <Translate content="computeResource.vgpu.placements.placementId" />,
    },
    {
        key: 'colAddress',
        title: <Translate content="computeResource.vgpu.placements.address" />,
    },
    {
        key: 'colServer',
        title: <Translate content="computeResource.vgpu.placements.virtualServer" />,
    },
];

const VGPUPlacements: FC<IProps> = ({ gpu }) => {
    const data = gpu.placement_addresses.map(item => ({
        id: item.id,
        colPlacementID: item.placement_id,
        colAddress: item.address,
        colServer: item.server ? (
            <Action
                href={pathTo(`servers/${item.server.id}`)}
                target="_blank"
            >
                {item.server.name}
            </Action>
        ) : null,
    }));

    return (
        <List
            columns={COLUMNS}
            data={data}
            rowKey={'id'}
        />
    );
};

export default memo(VGPUPlacements);
